export const STATUS_MAP = {
  in_attesa: {
    label: "In Attesa di Conferma",
    cls: "bg-amber-50 text-amber-700 border-amber-200",
  },
  autorizzato: {
    label: "Autorizzato al Pagamento",
    cls: "bg-blue-50 text-blue-700 border-blue-200",
  },
  pagato: {
    label: "Pagato",
    cls: "bg-emerald-50 text-emerald-700 border-emerald-200",
  },
};

export default function StatusBadge({ status }) {
  const s = STATUS_MAP[status] || STATUS_MAP.in_attesa;
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold border ${s.cls}`}
    >
      {s.label}
    </span>
  );
}
